<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1300px"
      show-save-button
      unit="调拨单"
      edit-title
      id-key="commentId"
      :data="data"
      :form-rules="rules"
      :get-data-func="api.info"
      :save-func="api.save"
      :before-save="onBeforeSave"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      close-on-saved
      @close-saved="$emit('close-saved')"
      @close="onClose"
    >
      <template slot="form">
        <el-row>
          <el-col :span="6">
            <el-form-item label="单据编号" prop="DocNo">
              <el-input
                v-model="data.DocNo"
                placeholder="请输入单据编号"
                v-if="noEdit"
              ></el-input>
              <span v-else>{{ data.DocNo }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="单据日期" prop="DocDate">
              <el-date-picker
                size="mini"
                v-model="data.DocDate"
                placeholder="请选择日期"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="调出仓库" prop="OutWarehouseId">
              <el-select
                size="mini"
                v-model="data.OutWarehouseId"
                placeholder="请选择"
                clearable
                @change="checkWare(data.OutWarehouseId,'out')"
                :disabled="isSelDisabled"
              >
                <el-option v-for="item in wareList" :key="item.WarehouseId" :label="item.WarehouseName" :value="item.WarehouseId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="调入仓库" prop="InWarehouseId">
              <el-select
                size="mini"
                v-model="data.InWarehouseId"
                placeholder="请选择"
                clearable
                @change="checkWare"
              >
                <el-option v-for="item in wareList" :key="item.WarehouseId" :label="item.WarehouseName" :value="item.WarehouseId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="调拨类型" prop="AllotType">
              <el-select
                size="mini"
                v-model="data.AllotType"
                placeholder="请选择"
                clearable
              >
                <el-option label="同价调拨" :value="0"></el-option>
                <el-option label="异价调拨" :value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注" prop="Remark">
              <el-input
                type="textarea"
                v-model="data.Remark"
                placeholder="请输入备注"
              ></el-input>
            </el-form-item>
          </el-col>
          <dialog-list ref="dialogList" :info="data" :AllotType="data.AllotType" :isCreation="isCreation"  @onSelect="onSelect" />
        </el-row>
      </template>
      <template slot="footer">
        <el-button size="mini" type="danger" @click="cancelExamine" v-if="data.Status==2&&canExa">弃 审</el-button>
        <el-button size="mini" type="success" @click="examine" v-else-if="canExa">审 核</el-button>
      </template>
    </common-dialog>
    <sa-dialog ref="saDialog" in-dialog selectable @select="setSa" />
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import dialogList from "./dialogList";
import saDialog from "@/components/sales/business/salesorder/saListDialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    dialogList,
    saDialog
  },
  data() {
    return {
      data: {
        DocId: 0,
        DocNo: "",
        DocDate: "",
        AllotType: 0,
        Remark: "",
        OrderNo: "",
        OrderId: 0,
        OutWarehouseId: null,
        InWarehouseId: null,
        Status: 0,
        Goods:[]
      },
      noEdit: false,
      canExa: false,
      wareList: [],
      tableData: [],
      initTableData:[
        {
        T: 0,
        DocGoodsId: 0,
        DocId: 0,
        OrderGoodsId: 0,
        BarCode: "",
        GoodsId:  0,
        GoodsName: "",
        Model: "",
        UnitId: 0,
        UnitName: "",
        Quantity: 0,
        BatchNo:"",
        Offer: 0,
        OutCost: 0,
        OutAmount: 0,
        InCost: 0,
        InAmount: 0,
        Remark: "",
        Thumbnail: "",
        AddTime: "",
        Quantity: 0,
        ExistQuantity: 0
        }
      ],
      api: require("@/api/stock/allotDoc").default,
      billApi: require("@/api/sy/bill").default,
      rules: {
        AllotType: [{ required: true, message: "调拨类型不能为空" }],
        OutWarehouseId: [{ required: true, message: "调出仓库不能为空" }],
        InWarehouseId: [{ required: true, message: "调入仓库不能为空" }],
      },
      isSelDisabled: false,
      isCreation: true,
    };
  },
  computed: {},
  beforeMount() {
    let date = new Date()
    date.setTime(date.getTime());
    let today = date.getFullYear()+"-" + (date.getMonth()+1) + "-" + date.getDate();
    if(!this.data.DocDate) {
      this.data.DocDate = today
    }
  },
  methods: {
    onClose(){
      this.isSelDisabled = false
    },
    onSelect(){
      this.isSelDisabled = true
    },
    addSa() {
      this.$refs.saDialog.open().then((that) => {
        that.getData();
      });
    },
    setSa(e) {
      
      this.data.OrderNo = e.OrderNo
      this.data.OrderId = e.OrderId
      this.$refs.dialogList.getData()
    },
    checkWare(e,type) {
      if(e&&(this.data.OutWarehouseId == this.data.InWarehouseId)) {
        this.$message.error("调出仓库与调入仓库不能相同")
        this.data.InWarehouseId = null
      }
      if(type=='out') {
        this.$refs.dialogList.tableData = JSON.parse(JSON.stringify(this.initTableData))
        this.$refs.dialogList.tableDel = []
      }
    },
    examine() {
      this.$confirm("确认审核数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
      .then(() => {
        this.api.examine(this.data.DocId).then(res => {
          if(res.Code ==0) {
            this.$message.success("审核成功")
            this.close()
            this.$emit("close-saved")
          } else {
            this.$message.error(res.Msg)
          }
        })
      })
    },
    cancelExamine() {
      this.$confirm("确认弃审数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
      .then(() => {
        this.api.cancelExamine(this.data.DocId).then(res => {
          if(res.Code ==0) {
            this.$message.success("弃审成功")
            this.close()
            this.$emit("close-saved")
          } else {
            this.$message.error(res.Msg)
          }
        })
      })
    },
    onCreateOpened() {
      this.isSelDisabled = false
      this.isCreation = false 
      this.canExa = false
      this.wareList = JSON.parse(sessionStorage.getItem("ware"))
      this.$refs.dialogList.tableData = []
      this.$refs.dialogList.tableDel = []
      this.billApi.getDefaultSerialNo("调拨单").then(res => {
        if(res.Code==0&&res.Data) {
          this.data.DocNo = res.Data
        } else if(res.Code==0) {
          this.noEdit = true
        } else {
          this.$message.warning(res.Msg)
        }
      })
      this.$notify({
        title: '提示',
        message: '如果修改调出仓库会重置表格，需要重新编辑',
        duration: 5000
      });
    },
    onEditOpened(row) {
      this.isSelDisabled = true
      this.isCreation = true 
      this.canExa = true
      this.$refs.dialogList.tableDel = []
      this.wareList = JSON.parse(sessionStorage.getItem("ware"))
      this.$refs.dialogList.getData()
      this.$notify({
        title: '提示',
        message: '如果修改调出仓库会重置表格，需要重新编辑',
        duration: 5000
      });
    },
    onBeforeSave() {
      let tableData = this.$refs.dialogList.tableData;
      let tableDel = this.$refs.dialogList.tableDel;
      let tb = []
      if(tableData.length==0 || !tableData.some(v=>v.GoodsId)) {
        this.$message.error("请填写商品列表");
        return false;
      }
      for(var i = 0; i < tableData.length; i++) {
        if(tableData[i].GoodsId){
        if(!tableData[i].Quantity) {
          this.$message.error("请填写数量");
          return false;
        }
        if(tableData[i].T===0||tableData[i].T===1) {
          tb.push(tableData[i])
        }
        }
      }
      this.data.Goods = tb.concat(tableDel)
      
      return true
    },
  },
};
</script>